export const databoxOfficialGridItemFrag = `
    id
    name
    type
`;
